import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Toast, { useToast } from 'vue-toastification';
import 'vue-toastification/dist/index.css';

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    faEnvelope,
    faUser,
    faUsers,
    faLocationDot,
    faPen,
    faCheck,
    faArrowRight,
    faArrowLeft,
    faSpinner,
    faSignOutAlt,
    faLandmark,
    faPaperPlane,
    faHistory,
    faInfoCircle,
    faCreditCard,
    faEraser,
    faUndo,
    // Template icons
    faHeart,
    faLeaf,
    faGraduationCap,
    faBriefcase,
    faGlobe,
    faMedal,
    faShieldAlt,
    faRoad,
    faGavel,
    faHome,
    // Share icons
    faLink,
    faShareAlt,
} from '@fortawesome/free-solid-svg-icons';
import {
    faXTwitter,
    faFacebookF,
} from '@fortawesome/free-brands-svg-icons';

library.add(
    faEnvelope,
    faUser,
    faUsers,
    faLocationDot,
    faPen,
    faCheck,
    faArrowRight,
    faArrowLeft,
    faSpinner,
    faSignOutAlt,
    faLandmark,
    faPaperPlane,
    faHistory,
    faInfoCircle,
    faCreditCard,
    faEraser,
    faUndo,
    // Template icons
    faHeart,
    faLeaf,
    faGraduationCap,
    faBriefcase,
    faGlobe,
    faMedal,
    faShieldAlt,
    faRoad,
    faGavel,
    faHome,
    // Share icons
    faLink,
    faShareAlt,
    faXTwitter,
    faFacebookF,
);

const app = createApp(App);

app.component('font-awesome-icon', FontAwesomeIcon);

app.use(router);
app.use(store);
app.use(Toast, {
    position: 'top-right',
    timeout: 3000,
    closeOnClick: true,
    pauseOnHover: true,
});

// Make toast available globally for Options API components
app.config.globalProperties.$toast = useToast();

// Initialize auth before mounting
store.dispatch('initAuth').then(() => {
    app.mount('#app');
});
